import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=e52d53bc&scoped=true&"
import script from "./ProductNew.vue?vue&type=script&lang=js&"
export * from "./ProductNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=e52d53bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52d53bc",
  null
  
)

export default component.exports